import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { api } from '../api';
import { useI18n } from '../i18n';
import { Plate } from '../ui/chrome';
import { SmallPageDecor } from './Success';

/**
 * Arriving from the app: /handoff?code=…&product=… (or &page=account). The code leaves the address
 * bar (and history) before anything else, then becomes this browser's session as the app's player,
 * and the shop opens on the product they tapped, or the account page opens.
 */
export function HandoffPage() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);
  const [shop, setShop] = useState('/shop');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // StrictMode runs effects twice; a code works once
    ran.current = true;
    const query = new URLSearchParams(window.location.search);
    const code = query.get('code');
    const product = query.get('product');
    const target = query.get('page') === 'account' ? '/account' : product && /^[a-z0-9_]{1,40}$/.test(product) ? `/shop?product=${product}` : '/shop';
    setShop(target);
    window.history.replaceState(null, '', '/handoff');
    if (!code) return setFailed(true);
    api.redeemHandoff(code).then(
      () => navigate(target, { replace: true }),
      () => setFailed(true),
    );
  }, [navigate]);

  return (
    <section className="small-page">
      <SmallPageDecor />
      <div className="wrap">
        <div className="card done">
          {failed ? (
            <>
              <Plate as="h1" large petal>
                {t('handoff.failed')}
              </Plate>
              <p>{t('handoff.failedBody')}</p>
              <Link className="btn btn-pink" to={`/login?next=${encodeURIComponent(shop)}`}>
                {t('nav.login')}
              </Link>
            </>
          ) : (
            <p className="muted" style={{ paddingTop: 36 }}>
              {t('handoff.signingIn')}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
